var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMutation } from 'react-apollo';
import subscribeToNewsletterMutation from '@jetshop/core/data/mutations/subscribeToNewsletter.gql';
import { useStoreSubscriptions } from './useStoreSubscriptions';
function useNewsletterSubscription({ enabled }) {
    var _a;
    const [subscribeMutation] = useMutation(subscribeToNewsletterMutation);
    const _b = useStoreSubscriptions({
        services: { trySubmit },
        enabled
    }), { fields, input, error } = _b, rest = __rest(_b, ["fields", "input", "error"]);
    function trySubmit() {
        return new Promise((resolve, reject) => {
            return subscribeMutation({
                variables: {
                    email: fields.email
                }
            })
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }
    const errorStates = {
        invalidEmail: Array.isArray(error) && error.includes('UnableToSubscribeToNewsletter'),
        alreadySubscribed: Array.isArray(error) && error.includes('AlreadySubscribed')
    };
    const inputProps = Object.assign(Object.assign({}, input), { name: 'email', value: (_a = fields.email) !== null && _a !== void 0 ? _a : '' });
    return Object.assign(Object.assign(Object.assign({}, fields), rest), { inputProps,
        errorStates });
}
export { useNewsletterSubscription };
//# sourceMappingURL=useNewsletterSubscription.js.map